import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_CLOSURE_BASE_PATH = '/CaseClosure';

export const caseClosureEndpoints = {
  active:        (caseId: ID) => buildEndpointWithParams(`${CASE_CLOSURE_BASE_PATH}/by-case/:caseId/active`,         { caseId }),
  history:       (caseId: ID) => buildEndpointWithParams(`${CASE_CLOSURE_BASE_PATH}/by-case/:caseId/history`,        { caseId }),
  reasonOptions: (caseId: ID) => buildEndpointWithParams(`${CASE_CLOSURE_BASE_PATH}/by-case/:caseId/reason-options`, { caseId }),
  close:         (caseId: ID) => buildEndpointWithParams(`${CASE_CLOSURE_BASE_PATH}/by-case/:caseId/close`,          { caseId }),
  reopen:        (caseId: ID) => buildEndpointWithParams(`${CASE_CLOSURE_BASE_PATH}/by-case/:caseId/reopen`,         { caseId }),
} as const;

export const CASE_HOLD_BASE_PATH = '/CaseHold';

export const caseHoldEndpoints = {
  current:       (caseId: ID) => buildEndpointWithParams(`${CASE_HOLD_BASE_PATH}/by-case/:caseId/current`,       { caseId }),
  history:       (caseId: ID) => buildEndpointWithParams(`${CASE_HOLD_BASE_PATH}/by-case/:caseId/history`,       { caseId }),
  reasonOptions: (caseId: ID) => buildEndpointWithParams(`${CASE_HOLD_BASE_PATH}/by-case/:caseId/reason-options`, { caseId }),
  hold:          (caseId: ID) => buildEndpointWithParams(`${CASE_HOLD_BASE_PATH}/by-case/:caseId/hold`,          { caseId }),
  resume:        (caseId: ID) => buildEndpointWithParams(`${CASE_HOLD_BASE_PATH}/by-case/:caseId/resume`,        { caseId }),
} as const;

// Suppress unused import warning if base helpers aren't used elsewhere
void buildEndpoint;
